import { render, staticRenderFns } from "./ManualBet.vue?vue&type=template&id=e365406c&scoped=true&"
import script from "./ManualBet.vue?vue&type=script&lang=js&"
export * from "./ManualBet.vue?vue&type=script&lang=js&"
import style0 from "./ManualBet.vue?vue&type=style&index=0&id=e365406c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e365406c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e365406c')) {
      api.createRecord('e365406c', component.options)
    } else {
      api.reload('e365406c', component.options)
    }
    module.hot.accept("./ManualBet.vue?vue&type=template&id=e365406c&scoped=true&", function () {
      api.rerender('e365406c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/ManualBet.vue"
export default component.exports